import { Box, Button, Dialog, TextField, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 600,
  minHeight: 200,
  padding: '40px 80px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));

export const ButtonBox = styled(Box)(() => ({
  margin: '20px 0',
  display: 'flex',
  gap: '40px',
  justifyContent: 'center',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& .MuiInputBase-root': { borderRadius: '16px' },
  '& .MuiInputBase-root.MuiInput-root:before': {
    borderBottom: '1px solid #D7D8DB99',
  },
  '& .MuiInputBase-root.MuiInput-root:after': {
    borderBottom: '1px solid #D7D8DB99',
  },
  '& .MuiInputBase-root.MuiInput-root.Mui-error:before': {
    borderBottom: '1px solid #d32f2f',
  },
  '& .MuiInputBase-root.MuiInput-root.Mui-error:after': {
    borderBottom: '1px solid #d32f2f',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:before': {
    borderBottom: '1px solid #D7D8DB99',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:after': {
    borderBottom: '1px solid #D7D8DB99',
  },
  'input:-webkit-autofill': {
    WebkitBoxShadow: `0 0 0px 1000px ${theme.palette.common.white} inset`,
  },
}));

export const FilledDarkButton = styled(Button)(({ theme }) => ({
  borderRadius: '16px',
  width: '100%',
  backgroundColor: theme.palette.secondary.main,
  color: '#FAFCFF',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const OutlinedDarkButton = styled(Button)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: '10px',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '16px',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));
